import type { WorkComment, WorkFile } from '../api/client';

/**
 * A ticket's thread: what was said, and what was attached, in the order it
 * happened. A file that came with an update sits under that update; one
 * attached on its own is its own entry ("Attached invoice.pdf").
 */

export type TimelineItem =
  | { kind: 'comment'; id: string; at: string; authorName: string | null; body: string; files: WorkFile[] }
  | { kind: 'file'; id: string; at: string; authorName: string | null; file: WorkFile };

export function mergeTimeline(comments: ReadonlyArray<WorkComment>, files: ReadonlyArray<WorkFile>): TimelineItem[] {
  const known = new Set(comments.map((c) => c.id));
  const byComment = new Map<string, WorkFile[]>();
  const alone: WorkFile[] = [];
  for (const f of files) {
    if (f.commentId && known.has(f.commentId)) {
      const list = byComment.get(f.commentId) ?? [];
      list.push(f);
      byComment.set(f.commentId, list);
    } else {
      alone.push(f);
    }
  }
  const items: TimelineItem[] = [
    ...comments.map((c): TimelineItem => ({
      kind: 'comment',
      id: c.id,
      at: c.createdAt,
      authorName: c.authorName,
      body: c.body,
      files: byComment.get(c.id) ?? [],
    })),
    ...alone.map((f): TimelineItem => ({ kind: 'file', id: f.id, at: f.createdAt, authorName: f.uploaderName, file: f })),
  ];
  return items.sort((a, b) => (a.at < b.at ? -1 : a.at > b.at ? 1 : a.id < b.id ? -1 : a.id > b.id ? 1 : 0));
}
